import React, {Component} from 'react';
import Header from './Header';
import Clock from './Clock';
import Footer from './Footer';
class Home extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {

    }

    render() {
        return (
            <div className="content-wrapper">
                <Header />
                <Clock />
                <Footer/>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/views/Home.js